import { render } from "./TheName.vue?vue&type=template&id=5a5405be&scoped=true&lang=html"
import script from "./TheName.vue?vue&type=script&lang=js"
export * from "./TheName.vue?vue&type=script&lang=js"

import "./TheName.vue?vue&type=style&index=0&id=5a5405be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5405be"]])

export default __exports__